import { useState, useEffect } from 'react';
import { API_PREFIX_LEGACY } from '@/const/api';
import { Client } from '@lemonade-hq/nuiza';

export const PARTNER_NAMES: Record<string, string> = {
  gusto: 'Gusto',
} as const;

export interface AffiliateDiscount {
  partnerCode: string;
  discountPercent?: number;
}

interface AffiliateDiscountApiResponse {
  data: AffiliateDiscount;
}

export const useAffiliateDiscount = () => {
  const [affiliateDiscount, setAffiliateDiscount] = useState<AffiliateDiscount | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const affiliateDiscountToken = urlParams.get('affiliate_discount_token');

    if (!affiliateDiscountToken) {
      setIsLoading(false);
      return;
    }

    void Client.get<AffiliateDiscountApiResponse>(
      `${process.env.NEXT_PUBLIC_MONOLITH_URL}/${API_PREFIX_LEGACY}/affiliate_discounts/proxy?token=${affiliateDiscountToken}`,
    )
      .then(response => {
        setAffiliateDiscount(response.data);
        setIsLoading(false);
      })
      .catch(() => {
        setAffiliateDiscount(null);
        setIsLoading(false);
      });
  }, []);

  return { affiliateDiscount, isLoading };
};

export const isAffiliateDiscountValid = (affiliateDiscount: AffiliateDiscount | null): boolean => {
  return affiliateDiscount?.discountPercent && PARTNER_NAMES[affiliateDiscount.partnerCode] ? true : false;
};
